import React, { useState, useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import LoaderGif from "../../assets/images/Loader_recolored_transparent.gif";
import GenAIChat from "../../assets/images/GenAIChat.svg";

import { LoadingMessages } from "../../utils/constantFiles/constant";

import "./ChatLoading.scss";

function ChatLoading() {
  const [loadingIndex, setLoadingIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingIndex((prevIndex) => {
        if (prevIndex < LoadingMessages.length - 1) {
          return prevIndex + 1;
        }
        return prevIndex;
      });
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Stack spacing={1} direction="row" className="chat-loading-section">
      <img src={GenAIChat} alt="logo" className="img-logo-while-loading" />
      <img src={LoaderGif} alt="loader-gif" className="img-loader-gif" />
      <Typography className="loading-text">
        {LoadingMessages[loadingIndex]}
      </Typography>
    </Stack>
  );
}

export default ChatLoading;
